import { Host, h } from '@stencil/core';
export class AibaArticle {
  constructor() {
    this.detail = undefined;
    this.isButtonEnabled = undefined;
    this.data = undefined;
    this.handlers = undefined;
    this.styles = undefined;
  }
  render() {
    if (typeof this.data === 'string' || typeof this.handlers === 'string' || typeof this.detail === 'string') {
      if (this.data)
        this.data = JSON.parse(this.data);
      if (this.handlers)
        this.handlers = JSON.parse(this.handlers);
      if (this.detail)
        this.detail = JSON.parse(this.detail);
    }
    return (h(Host, null, this.styles && h("style", null, this.styles), this.data &&
      this.data['article'] &&
      this.data['article']['data'] &&
      this.data['article']['data']['elements'] &&
      this.data['article']['data']['elements'].map((component) => {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        if (component && component['name'] === 'aiba-img')
          return (h("div", { class: "c-article__image" }, h("img", Object.assign({}, component['data'], { src: (_a = this.detail) === null || _a === void 0 ? void 0 : _a.imageUrl, alt: (_b = this.detail) === null || _b === void 0 ? void 0 : _b.imageAltText }))));
        if (component && component['name'] === 'aiba-label-1')
          return (h("div", { class: "c-article__info-title" }, h("aiba-label", Object.assign({}, component['data'], { text: (_c = this.detail) === null || _c === void 0 ? void 0 : _c.title }))));
        if (component && component['name'] === 'aiba-label-2' && ((_d = this.detail) === null || _d === void 0 ? void 0 : _d.description))
          return (h("div", { class: "c-article__info-desc" }, h("aiba-label", Object.assign({}, component['data'], { text: (_e = this.detail) === null || _e === void 0 ? void 0 : _e.description }))));
        if (component && component['name'] === 'aiba-link')
          return (h("div", { class: "c-article__info-link" }, h("aiba-link", Object.assign({ href: (_f = this.detail) === null || _f === void 0 ? void 0 : _f.pageUrl, arialabel: (_g = this.detail) === null || _g === void 0 ? void 0 : _g.title, onClick: (event) => {
              this.handlers && this.handlers.handleArticleClicked && this.handlers.handleArticleClicked(event, this.detail);
            }, "data-product": this.detail ? JSON.stringify(this.detail) : '', title: (_h = this.detail) === null || _h === void 0 ? void 0 : _h.type }, component['data']), component &&
            component['data'] &&
            component['data']['data'] &&
            component['data']['data']['elements'] &&
            component['data']['data']['elements'].map((innerComponent) => {
              var _a, _b, _c;
              if (innerComponent && innerComponent['name'] === 'aiba-label-1' && !this.isButtonEnabled)
                return h("aiba-label", Object.assign({}, innerComponent['data'], { arialabel: (_a = this.detail) === null || _a === void 0 ? void 0 : _a.title }));
              if (innerComponent && innerComponent['name'] === 'aiba-label-2' && !this.isButtonEnabled)
                return h("aiba-label", Object.assign({}, innerComponent['data'], { arialabel: (_b = this.detail) === null || _b === void 0 ? void 0 : _b.title, text: (_c = this.detail) === null || _c === void 0 ? void 0 : _c.title }));
              if (innerComponent && innerComponent['name'] === 'aiba-img' && !this.isButtonEnabled)
                return h("img", Object.assign({}, innerComponent['data']));
              if (innerComponent && innerComponent['name'] === 'aiba-button' && this.isButtonEnabled)
                return h("aiba-button", Object.assign({}, innerComponent['data']));
            }))));
      })));
  }
  static get is() { return "aiba-article"; }
  static get originalStyleUrls() {
    return {
      "$": ["aiba-article.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["aiba-article.css"]
    };
  }
  static get properties() {
    return {
      "detail": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "RecommendedArticlesType | any",
          "resolved": "any",
          "references": {
            "RecommendedArticlesType": {
              "location": "import",
              "path": "./types"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "detail",
        "reflect": false
      },
      "isButtonEnabled": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "is-button-enabled",
        "reflect": false
      },
      "data": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "data",
        "reflect": false
      },
      "handlers": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "handlers",
        "reflect": false
      },
      "styles": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "styles",
        "reflect": false
      }
    };
  }
}
//# sourceMappingURL=aiba-article.js.map
